import { Injectable } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
  })
export class Settings{
    moduleImageHeight = 262;
    moduleImageWidth = 468;

    userImageHeight = 200;
    userImageWidth = 200;
    //private static me: Settings;
    public constructor(){

    }
    // static getSettings(){
    //     if(!this.me)
    //     {
    //         this.me = new Settings();
    //     }
    //     return this.me;
    // }

}

export class UploadLayout{
  URLRegex: string;
  File: File;
  FileName: string;
  Description: string;
  SchoolId: number;
}

export class LayoutFile{
  id:number;
  description: string;
  urlRegex: string;
  filePath: string;
  fileName:string;
  fileurl:string;
  safeUrl: SafeUrl = null;
  loaded: boolean = false;
}
export class LayoutImage{
  id:number;
  filePath: string;
  fileName:string;
  safeUrl: string;
}
export class CertificateFile{
  id:number;
  filePath: string;
  fileName:string;
  url: string;
  inUse:boolean
}
